/* eslint-env browser */
const about = document.querySelector('.about')
const aboutToggle = (e = window.event) => {
  fastdom.mutate(() => {
    noScroll()
    about.classList.toggle('--ativo')
  })
}

const aboutKill = () => {
  if (about.classList.contains('--ativo')) {
    aboutToggle()
  }
}

if (about) {
  window.addEventListener('resize', aboutKill, false)
}
